import { MdCancel } from "react-icons/md";
import { VscRemote, VscCheck } from "react-icons/vsc";
import { MdOutlineAdminPanelSettings } from "react-icons/md";

export const DaoStatus = {
    'APPROVED': {
        text: 'Approved',
        color: 'green.500',
        icon: VscCheck
    },
    'DECLINED': {
        text: 'Declined',
        color: 'red.500',
        icon: MdCancel
    },
    'IN_PROGRESS': {
        text: 'In progress',
        color: 'brand.200',
        icon: VscRemote
    },
    'PENDING_ADMIN_APPROVAL': {
        text: 'Pending Admin Approval',
        color: 'yellow.400',
        icon: MdOutlineAdminPanelSettings
    },
}


